import React from 'react';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import VerticalNavigation from '../navigation/vertical-navigation';
import useTranslate from '../useTranslate';
import ObjectsOverviewCard from './objects-overview-card';
import { usePbSelector } from '../../store/pbStoreHooks';

function ObjectsOverview() {
    const strings = useTranslate('ObjectsOverview');
    const mansionsById = usePbSelector((state) => state.mansions.mansionsById);

    return (
        <Row>
            <LeftSide addClass="">
                <VerticalNavigation selected="objects" objects={mansionsById} />
            </LeftSide>

            <Col xs={9} className="col-middle">
                <ObjectsOverviewCard title={strings.objects} allowCreate />
            </Col>
        </Row>
    );
}

export default ObjectsOverview;
